namespace Dashboard {

    export class NotificationLink {
        private desktopUrl: string = 'desktop-url/{{SiteId}}/{{BookingId}}/{{LastName}}';
        private notificationLinks: any = {
            1: '/dashboard/csr/{{::BookingId}}',
            2: '/dashboard/csr/{{::BookingId}}',
            3: '/dashboard/pay-balance/{{::BookingId}}',
            4: this.desktopUrl + '/api',
            6: 'review-hotel/{{::BookingId}}'
            //0,5,6,7,8,9 type of notifications are there.. need link for them
        };
        public get() {
            return angular.copy(this.notificationLinks);
        }
    }

    angular
        .module('dashboard')
        .service('notificationLink', NotificationLink);

}
